import { createContext, useContext } from "react";

import { SchematisationRevision, ThreediModel } from "@nens/threedi/openapi-client";

import { SchematisationWithId } from "@/queries/query-hcc-schematisation";

export type SchematisationDetailsMode = "project" | "catalogue";

export type SchematisationRevisionWithId = SchematisationRevision & { id: number };

// The provider only renders its children once the schematisation and revision are loaded.
export type SchematisationDetailsContextValue = {
  mode: SchematisationDetailsMode;
  schematisation: SchematisationWithId;
  revision: SchematisationRevisionWithId;
  // null when the revision has no 3Di model (yet)
  threediModel: ThreediModel | null;
};

export const SchematisationDetailsContext = createContext<SchematisationDetailsContextValue | null>(
  null
);

/**
 * Hook to access schematisation details from context.
 * Must be used within a ModelSchematisationDetails component tree.
 */
export function useSchematisationDetailsContext(): SchematisationDetailsContextValue {
  const context = useContext(SchematisationDetailsContext);
  if (!context) {
    throw new Error(
      "useSchematisationDetailsContext must be used within ModelSchematisationDetails"
    );
  }
  return context;
}
